import {Component, Input, OnChanges, SimpleChange} from "@angular/core";
import FormUtils from "../../../../../../utils/form-utils.component";

@Component({
  selector: "field-set-classification",
  templateUrl: "./field-set-classification.component.html",
  styles: [],
})
export class FieldSetClassificationComponent implements OnChanges {
  @Input() public fieldOptions: any;
  @Input() public fields: any;
  @Input() public classificationsList: any[];
  public classificationFields: any[] = [];

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.mapClassificationFields();
  }

  public mapClassificationFields() {
    if (this.fields) {
      this.classificationFields = [];
      this.fields.map((field) => {
        if (field.inputType === "classification" && field.key !== this.fieldOptions.key) {
          this.classificationFields.push(field);
        }
      });
    }
  }

  public mapClassificationFieldFromTable(field: any) {
    if (field.rows) {
      field.rows.forEach((row) => {
        row.forEach((cell) => {
          cell.components.forEach((cellField) => {
            if (cellField.inputType === "classification" && cellField.key !== this.fieldOptions.key) {
              this.classificationFields.push(cellField);
            }
          });
        });
      });
    } else if (field.schema) {
      field.schema.components.forEach((comp) => {
        if (comp.inputType === "classification" && comp.key !== this.fieldOptions.key) {
          this.classificationFields.push(comp);
        } else if (comp.inputType === "table") {
          this.mapClassificationFieldFromTable(comp);
        }
      });
    }
  }

}
